require('angular').module('wowApp.shop')
    .directive('wowSocialButtons', [require('./social-buttons-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/socialmedia/index.js
 **/